/* =============================================================================
   Furniselan — quick view
   ============================================================================= */
(function () {
  'use strict';

  var FS = window.FS, qs = FS.qs, once = FS.once, T = FS.T, Overlay = FS.Overlay;

  var qvCache = {};

  var QuickView = {
    modal: function () { return qs('[data-quick-view-modal]'); },
    prefetch: function (url) {
      if (!url) return;
      var sep = url.indexOf('?') > -1 ? '&' : '?';
      var fetchUrl = url + sep + 'view=quick-view&section_id=quick-view';
      if (qvCache[fetchUrl]) return;
      fetch(fetchUrl)
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (html) qvCache[fetchUrl] = html;
        })
        .catch(function () {});
    },
    open: function (url, btn) {
      var modal = this.modal(), body = modal && qs('[data-quick-view-body]', modal);
      if (!url || !modal || !body) { if (url) window.location.href = url; return; }

      var sep = url.indexOf('?') > -1 ? '&' : '?';
      var fetchUrl = url + sep + 'view=quick-view&section_id=quick-view';

      // Instant cache hit - zero latency
      if (qvCache[fetchUrl]) {
        body.innerHTML = qvCache[fetchUrl];
        if (btn) btn.classList.remove('is-loading');
        Overlay.show(modal);
        try {
          window.Furniselan.init(body);
        } catch (initErr) {
          if (window.console) console.error('Quick view cached init error:', initErr);
        }
        if (window.FS && typeof window.FS.initVariantSelector === 'function') {
          window.FS.initVariantSelector(body);
        }
        return;
      }

      if (btn) btn.classList.add('is-loading');
      body.innerHTML = '<p class="quick-view__loading">' + (T.strings.loading || 'Loading…') + '</p>';
      Overlay.show(modal);

      fetch(fetchUrl)
        .then(function (r) {
          if (!r.ok) {
            if (window.console) console.error('Quick view HTTP ' + r.status + ' for ' + url);
            throw new Error('quick view fetch failed: HTTP ' + r.status);
          }
          return r.text();
        })
        .then(function (html) {
          qvCache[fetchUrl] = html;
          body.innerHTML = html;
          if (btn) btn.classList.remove('is-loading');
          try {
            window.Furniselan.init(body);
          } catch (initErr) {
            if (window.console) console.warn('Quick view: init error (non-fatal):', initErr);
          }
          if (window.FS && typeof window.FS.initVariantSelector === 'function') {
            window.FS.initVariantSelector(body);
          }
        })
        .catch(function (err) {
          if (window.console) console.error('Quick view could not load:', err);
          if (btn) btn.classList.remove('is-loading');
          body.innerHTML = '<p class="quick-view__error">' + (T.strings.quickViewError || 'Couldn\'t load this product.') +
            ' <a href="' + url + '">' + (T.strings.viewFullDetails || 'View full details') + '</a></p>';
        });
    }
  };

  function initQuickView(ctx) {
    var modal = QuickView.modal();
    if (modal && once(modal, 'QuickView')) {
      var closeBtn = FS.qs('[data-quick-view-close]', modal);
      function closeAnyVariantModal() {
        var openModals = document.querySelectorAll('.fs-variant-modal.is-open');
        openModals.forEach(function (m) { m.classList.remove('is-open'); });
      }
      if (closeBtn) closeBtn.addEventListener('click', function () {
        Overlay.hide(modal);
        closeAnyVariantModal();
      });
      modal.addEventListener('click', function (e) {
        if (e.target === modal) {
          Overlay.hide(modal);
          closeAnyVariantModal();
        }
      });
      modal.addEventListener('change', function (e) {
        var radio = e.target.closest('input[type="radio"][data-option-select]');
        if (!radio) return;

        // 1. Toggle .is-selected class on swatch labels in Quick View
        modal.querySelectorAll('.swatch').forEach(function (s) {
          var r = s.querySelector('input[type="radio"]');
          s.classList.toggle('is-selected', !!(r && r.checked));
        });

        // 2. Update Quick View Title
        var qvTitle = modal.querySelector('.quick-view__title, [data-qv-title-base]');
        var qvIdx = qvTitle ? parseInt(qvTitle.getAttribute('data-qv-color-index'), 10) : -1;
        var optIdx = parseInt(radio.getAttribute('data-option-index'), 10);
        if (qvTitle && (qvIdx === -1 || qvIdx === optIdx)) {
          var val = radio.value;
          var qvColor = qvTitle.querySelector('[data-qv-color]');
          var qvBase = qvTitle.querySelector('[data-qv-base]');
          var baseText = (qvBase && qvBase.textContent.trim()) || qvTitle.getAttribute('data-qv-title-base');
          if (qvColor) {
            qvColor.textContent = ' - ' + val;
          } else if (baseText) {
            qvTitle.innerHTML = '<span data-qv-base>' + baseText + '</span><span data-qv-color> - ' + val + '</span>';
          }
        }

        // 3. Find matching variant and update Quick View Image & Price
        var variantsEl = modal.querySelector('[data-variants]');
        if (variantsEl) {
          try {
            var vars = JSON.parse(variantsEl.textContent);
            var selectedOpts = [];
            modal.querySelectorAll('input[type="radio"][data-option-select]:checked').forEach(function (r) {
              var idx = parseInt(r.getAttribute('data-option-index'), 10);
              selectedOpts[idx] = r.value;
            });
            var matchedV = vars.find(function (v) {
              return selectedOpts.every(function (val, idx) {
                return val == null || v.options[idx] === val;
              });
            });
            if (matchedV) {
              // Update hidden variant ID
              var idInput = modal.querySelector('input[name="id"]');
              if (idInput) idInput.value = matchedV.id;

              // Update Image
              var img = modal.querySelector('.quick-view__media img');
              var imgUrl = (matchedV.featured_image && matchedV.featured_image.src) || (matchedV.featured_media && matchedV.featured_media.preview_image && matchedV.featured_media.preview_image.src);
              if (img && imgUrl) {
                var sep = imgUrl.indexOf('?') > -1 ? '&' : '?';
                img.removeAttribute('srcset');
                img.removeAttribute('sizes');
                img.src = imgUrl + sep + 'width=900';
              }

              // Update Price
              var priceEl = modal.querySelector('[data-product-price]');
              if (priceEl && window.FS && typeof window.FS.formatMoney === 'function') {
                var pText = window.FS.formatMoney(matchedV.price);
                if (matchedV.compare_at_price && matchedV.compare_at_price > matchedV.price) {
                  pText += ' <s>' + window.FS.formatMoney(matchedV.compare_at_price) + '</s>';
                }
                priceEl.innerHTML = pText;
              }

              // Update ATC button availability
              var atcBtn = modal.querySelector('[type="submit"]');
              if (atcBtn) {
                atcBtn.disabled = !matchedV.available;
                atcBtn.textContent = matchedV.available ? 'Add to Cart' : 'Sold out';
              }
            }
          } catch (err) {}
        }
      });
    }

    // Bind triggers with instant click and hover-prefetch
    FS.qsa('[data-quick-view-open], [data-add-to-cart][data-url], .product-card__atc', ctx).forEach(function (btn) {
      var url = btn.dataset.quickViewOpen || btn.dataset.url;
      if (!url) return;

      var prefetchHandler = function () {
        QuickView.prefetch(url);
      };
      btn.addEventListener('mouseenter', prefetchHandler, { once: true, passive: true });
      btn.addEventListener('touchstart', prefetchHandler, { once: true, passive: true });

      if (btn.dataset.quickViewOpen) {
        if (!once(btn, 'QVOpen')) return;
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          QuickView.open(btn.dataset.quickViewOpen, btn);
        });
      }
    });
  }

  window.FS.QuickView = QuickView;
  window.FS.initQuickView = initQuickView;
})();
